export const ObjectHelpers = {
  removeProperty: <T extends Record<string, unknown>, K extends keyof T>(obj: T, key: K): Omit<T, K> => {
    const { [key]: _, ...rest } = obj;
    return rest;
  },

  cleanObject: <T extends Record<string, unknown>>(
    obj: T,
    predicate: (key: keyof T, value: T[keyof T]) => boolean = (_, value) => value !== undefined,
  ): Partial<T> => {
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => predicate(key, value as T[keyof T])),
    ) as Partial<T>;
  },

  omitUndefined: <T extends Record<string, unknown>>(obj: T): Partial<T> => {
    return ObjectHelpers.cleanObject(obj, (_, value) => value !== undefined);
  },
};
